import React from 'react';
import { Box } from '@mui/material';
import WidgetWrapper from './WidgetWrapper';

const LEDIndicator = ({ 
  state = 'inactive',
  color = '#4caf50',
  offColor = '#cccccc',
  size = 24,
  label = '',
  blink = false,
  tagId = null,
  tagValue = null, // Will be injected by preview mode
  onClick = null, // Click handler for interactive mode
  // Style properties
  backgroundColor,
  foreColor,
  borderWidth,
  borderColor,
  borderRadius,
  fontSize,
  fontWeight,
  fontFamily,
  opacity,
  ...props 
}) => {
  // Use tag value if available, otherwise use static state
  const currentState = tagValue !== null && tagValue !== undefined ? tagValue : state;
  const isActive = currentState === 'active' || currentState === true || currentState === 1;


  // Use foreColor if provided, otherwise fall back to color prop
  const activeColor = foreColor || color || '#4caf50';
  const currentColor = isActive ? activeColor : offColor;

  // Context menu handler - dispatches global event
  const handleContextMenu = (event) => {
    if (tagId) {
      event.preventDefault();
      event.stopPropagation();

      // Dispatch global event to open Tag Info Modal
      const tagInfoData = {
        tagId: tagId,
        tagName: label || `LED ${tagId}`,
        tagName2: '',
        currentValue: currentState,
        unit: ''
      };
      window.dispatchEvent(new CustomEvent('openTagInfo', { detail: tagInfoData }));
    } else {
    }
  };

  // Don't use WidgetWrapper for LEDs - it creates unwanted rectangular background
  // LED should be just a circle, not wrapped in a box
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 1,
        width: '100%',
        height: '100%',
        opacity: opacity
      }}
      onContextMenu={handleContextMenu}
    >
      <Box
        sx={{
          width: `${size}px`,
          height: `${size}px`,
          borderRadius: '50%',
          backgroundColor: currentColor,
          boxShadow: isActive ? `0 0 ${size/2}px ${currentColor}` : 'none',
          border: '1px solid rgba(0,0,0,0.2)',
          animation: isActive && blink ? 'blink 1s infinite' : 'none',
          cursor: onClick ? 'pointer' : 'default',
          transition: 'all 0.2s ease',
          '@keyframes blink': {
            '0%, 100%': { opacity: 1 },
            '50%': { opacity: 0.3 }
          }
        }}
        onClick={onClick}
        title={onClick ? 'Click to toggle' : undefined}
      />
      {label && (
        <span style={{ fontSize: fontSize || 'inherit', color: foreColor || 'inherit' }}>{label}</span>
      )}
    </Box>
  );
};

export default LEDIndicator;